/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Starting_Translation_JobsInputs */

const en_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starting ${i?.count} translation job(s)... please wait.`)
};

const fr_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Démarrage de ${i?.count} tâche(s) de traduction... veuillez patienter.`)
};

const de_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übersetzungsauftrag(e) ${i?.count} werden gestartet... Bitte warten.`)
};

const it_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avvio di ${i?.count} lavori di traduzione... attendere.`)
};

const ru_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запуск задания(-ов) перевода ${i?.count}... пожалуйста, подождите.`)
};

const es_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciando ${i?.count} trabajo(s) de traducción... por favor espere.`)
};

const zh_cn2_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在开始 ${i?.count} 翻译任务……请稍候。`)
};

const ja_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の翻訳ジョブを開始しています... お待ちください。`)
};

const hi_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य शुरू हो रहा है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_starting_translation_jobs = /** @type {(inputs: Starting_Translation_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Iniciando a(s) tarefa(s) de tradução ${i?.count}... aguarde.`)
};

/**
* | output |
* | --- |
* | "Starting {count} translation job(s)... please wait." |
*
* @param {Starting_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const starting_translation_jobs = /** @type {((inputs: Starting_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starting_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_starting_translation_jobs(inputs)
	if (locale === "de") return de_starting_translation_jobs(inputs)
	if (locale === "it") return it_starting_translation_jobs(inputs)
	if (locale === "ru") return ru_starting_translation_jobs(inputs)
	if (locale === "es") return es_starting_translation_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_starting_translation_jobs(inputs)
	if (locale === "ja") return ja_starting_translation_jobs(inputs)
	if (locale === "hi") return hi_starting_translation_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_starting_translation_jobs(inputs)
	return en_starting_translation_jobs(inputs)
});